<script>
import appConfig from '@src/app.config'

export default {
  computed: {
    isIdle() {
      if (this.$store.state.idleVue.isIdle) {
        this.$router.push({
          name: 'logout',
        })
      }
      return this.$store.state.idleVue.isIdle
    },
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  mounted() {
    if (localStorage.getItem('relogin') == 'true') {
      localStorage.removeItem('auth.authDetails')
    }
    window.addEventListener('storage', this.storageChange, null)
  },
  created() {
    localStorage.setItem('storagetime', new Date().getTime())

    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    storageChange(event) {
      if (event.key === 'auth.authDetails') {
        // alert('Logged in: ' + event.newValue)
        // if (event.newValue == 'false') {

        window.location.reload()
        // }
      }
    },
    beforeWindowUnload(event) {
      // const pageAccessedByReload =
      //   (window.performance.getEntriesByType('navigation') &&
      //     window.performance.getEntriesByType('navigation').type === 1) ||
      //   window.performance
      //     .getEntriesByType('navigation')
      //     .map(nav => nav.type)
      //     .includes('reload')

      // if (pageAccessedByReload) {

      //   // do nothing
      // } else if (
      //   !pageAccessedByReload &&
      //   sessionStorage.getItem('auth.authDetails') != null
      // ) {
      //
      var localStorageTime = localStorage.getItem('storagetime')
      if (localStorageTime != null && localStorageTime != undefined) {
        var currentTime = new Date().getTime()
        var timeDifference = currentTime - localStorageTime
        if (timeDifference < 25) {
          // Browser Closed
          localStorage.removeItem('storagetime')
          window.sessionStorage.removeItem('auth.authDetails')
          window.localStorage.removeItem('auth.authDetails')
          // localStorage.setItem('isLoggedIn', false)
        } else {
          // Browser Tab Closed
          if (sessionStorage.getItem('auth.authDetails') != null) {
            localStorage.setItem('storagetime', new Date().getTime())
            window.localStorage.removeItem('auth.authDetails')
            // sessionStorage.removeItem('auth.authDetails')
            // localStorage.setItem('isLoggedIn', false)
          } else {
            // page refresh
            // alert('Page refresh detected')
          }
          // Perform any necessary actions or show a confirmation message
        }
      } else {
        localStorage.setItem('storagetime', new Date().getTime())
      }
      // localStorage.setItem('isLoggedIn', false)

      // }
    },
  },
}
</script>

<template>
  <div id="app">
    <p hidden>Is it Idle? - {{ isIdle }}</p>
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <router-view :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';

/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';

@import '~font-awesome/scss/font-awesome.scss';

/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';

@import '~simple-line-icons/scss/simple-line-icons.scss';

/* Import Flag Icons Set */
@import '~flag-icon-css/css/flag-icon.min.css';

/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import 'design/style';

@import '~vue-awesome-notifications/dist/styles/style.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $color-body-bg;
}

#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}
</style>
